import { render, staticRenderFns } from "./UploadAnnex.vue?vue&type=template&id=86f78e5c&"
import script from "./UploadAnnex.vue?vue&type=script&lang=js&"
export * from "./UploadAnnex.vue?vue&type=script&lang=js&"
import style0 from "./UploadAnnex.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports